import { useEffect, useState } from "react";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import api from "../../services/api";
import "./AddVerifiedModal.scss";

// Admin adds someone as a Verified DJ or Promoter directly, no request needed.
// The server finds their account by email or phone and approves them on the spot.
const KINDS = {
  dj: {
    title: "Add a Verified DJ",
    message: "They get the Verified DJ tag and guestlist access right away, plus a push saying they're verified. They need a ZONA account first.",
    endpoint: "/dj-requests/grant",
    nameKey: "djName",
    nameLabel: "DJ name (optional)",
  },
  promoter: {
    title: "Add a Verified Promoter",
    message: "They get the Verified Promoter tag and can create plans right away, plus a push saying they're verified. They need a ZONA account first.",
    endpoint: "/promoter-requests/grant",
    nameKey: "promoterName",
    nameLabel: "Promoter name (optional)",
    hasTeam: true,
  },
};

const EMPTY = { contact: "", name: "", instagram: "", company: "" };

const AddVerifiedModal = ({ isOpen, kind, onClose, onAdded }) => {
  const cfg = KINDS[kind];
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setForm(EMPTY);
      setError("");
    }
  }, [isOpen]);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async () => {
    const contact = form.contact.trim();
    if (!contact) return;
    const body = contact.includes("@") ? { email: contact } : { phone: contact };
    if (form.name.trim()) body[cfg.nameKey] = form.name.trim();
    const ig = form.instagram.trim().replace(/^@/, "");
    if (ig) body.instagram = ig;
    if (cfg.hasTeam && form.company.trim()) body.company = form.company.trim();

    setSaving(true);
    setError("");
    try {
      const res = await api.post(cfg.endpoint, body);
      onAdded(res.data?.message || "Added.");
    } catch (err) {
      setError(err?.response?.data?.message || "Could not add them. Try again.");
    } finally {
      setSaving(false);
    }
  };

  if (!cfg) return null;

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={cfg.title}
      message={cfg.message}
      confirmLabel="Add and approve"
      onConfirm={submit}
      onCancel={onClose}
      confirmDisabled={!form.contact.trim()}
      isLoading={saving}
    >
      <div className="add-verified-fields">
        <label>
          Email or phone
          <input value={form.contact} onChange={set("contact")} placeholder="name@email.com or 305 555 0123" autoFocus />
        </label>
        <label>
          {cfg.nameLabel}
          <input value={form.name} onChange={set("name")} />
        </label>
        <label>
          Instagram (optional)
          <input value={form.instagram} onChange={set("instagram")} placeholder="@handle" />
        </label>
        {cfg.hasTeam && (
          <label>
            Team (optional)
            <input value={form.company} onChange={set("company")} />
          </label>
        )}
        {error && <p className="add-verified-error">{error}</p>}
      </div>
    </ConfirmModal>
  );
};

export default AddVerifiedModal;
